import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, greyMui, rydeColors } from "@ryde/theme";

export const HelpTopicLanguageSwitcherStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "help-topic-language-switcher",
  },
)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 10px;
  border: 1px solid ${greyMui._200};
  background: ${greyMui._50};
  box-shadow: 0 1px 3px rgb(15 23 42 / 0.06);
`;

export const HelpTopicLanguageFlagButtonStyled = styled.button.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "help-topic-language-flag-button",
  },
)<{ $active: boolean }>`
  appearance: none;
  border: 1px solid ${({ $active }) => ($active ? blueMui._300 : "transparent")};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 52px;
  height: 32px;
  border-radius: 8px;
  padding: 0 8px;
  cursor: pointer;
  background: ${({ $active }) => ($active ? rydeColors.white : "transparent")};
  box-shadow: ${({ $active }) =>
    $active ? "0 1px 6px rgb(37 99 235 / 0.14)" : "none"};
  color: ${({ $active }) => ($active ? blueMui._700 : greyMui._700)};
  font-size: 0.75rem;
  font-weight: ${({ $active }) => ($active ? 700 : 600)};
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    color 0.15s ease;

  .HelpTopicLanguageSwitcher-Flag {
    font-size: 1rem;
    line-height: 1;
  }

  .HelpTopicLanguageSwitcher-Label {
    line-height: 1;
    letter-spacing: 0.02em;
  }

  &:hover:not(:disabled) {
    background: ${rydeColors.white};
    border-color: ${greyMui._300};
  }

  &:focus-visible {
    outline: 2px solid ${blueMui._400};
    outline-offset: 1px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.35;
    filter: grayscale(0.85);
  }
`;
